(function () {
    'use strict';

    function platformEntityReferralGenerator($rootScope, platformEntityReferralDataService, notifyService) {
        return {
            restrict: 'E',
            require: '^form',
            templateUrl: 'common/directives/templates/platformEntityReferralGenerator.html',
            scope: {
                referralData: '=',
                shareAction: '&',
                initiallyActivated: '=',
                hideButton: '=?',
                onActivated: '&',
                onClosed: '&'
            },
            link: function (scope, element, attrs, formController) {
                scope.formData = formController;
                scope.isActive = false;
                scope.activate = function() {
                    scope.isActive = true;
                    scope.onActivated();
                }

                scope.close = function(referralSubmitted) {
                    scope.isActive = false;
                    scope.companyName = '';
                    scope.firstName = '';
                    scope.emailAddress = '';
                    scope.onClosed(referralSubmitted);
                }

                if (scope.initiallyActivated) {
                    scope.activate();
                }

                scope.send = function() {
                    platformEntityReferralDataService.createPlatformEntityReferral({
                        PlatformId: scope.referralData.platformId,
                        SiteConfigurationId: scope.referralData.siteConfigurationId,
                        CompanyName: scope.formData.companyName.$viewValue,
                        FirstName: scope.formData.firstName.$viewValue,
                        LastName: scope.formData.lastName.$viewValue,
                        EmailAddress: scope.formData.emailAddress.$viewValue,
                        ReferralObject:
                        {
                            ReferrerEntityId: scope.referralData.referrerEntityId,
                            ObjectType: scope.referralData.objectType,
                            ObjectId: scope.referralData.objectId,
                            ObjectReferralPath: scope.referralData.objectReferralPath,
                            ObjectReferralMessage: scope.referralData.objectReferralMessage
                        }
                    }).then(function(data) {
                        if (data.ResponseType === 'Entity') {
                            scope.shareAction({ partner: data.Value });
                        }
                        else {
                            notifyService.notify('Your referral has been sent');
                        }
                        scope.close({referralSent: true});
                    }).catch(function(error) {
                        notifyService.notify('There was an error sending your referral', true);
                    });
                }

                $rootScope.$on('platformEntityReferralGeneratorActivated',
                    function(event, args) {
                        scope.activate();
                    });
            }
        };
    }

    platformEntityReferralGenerator.$inject = ['$rootScope', 'platformEntityReferralDataService', 'notifyService'];

    angular.module('ecap.common').directive('platformEntityReferralGenerator', platformEntityReferralGenerator);
})();